export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_quantity_hxJdOrderNo') || '京东采购订单',
    field: 'hxJdOrderNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    slots: { default: 'hxJdOrderNo' },
  },
  {
    title: that.$l('table_label_quantity_originalQty') || '采购数量',
    field: 'originalQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 80,
    isTotalColumn: true,
  },
  {
    title: that.$l('table_label_quantity_originalCtnQty') || '采购箱数',
    field: 'originalSubCtnQty',
    headerAlign: 'center',
    align: 'left',
    minWidth: 85,
    slots: { default: 'originalCtnQty' },
    isTotalColumn: true,
  },
  {
    title: that.$l('table_label_quantity_purchaseQty') || '出货数量',
    field: 'purchaseQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElInputNumber',
      props: {
        min: 0,
        max: 1000000000,
        step: 1,
        precision: 0,
        'controls-position': 'right',
        controls: false,
      },
    },
    isTotalColumn: true,
  },
  {
    title: that.$l('table_label_quantity_inCtnQty') || '出货入数',
    field: 'inCtnQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 90,
    editRender: {
      name: 'ElInputNumber',
      props: {
        min: 1,
        max: 100,
        step: 1,
        precision: 0,
        'controls-position': 'right',
        controls: false,
      },
    },
  },
  {
    title: that.$l('table_label_quantity_ctnQty') || '采购箱数',
    field: 'subCtnQty',
    headerAlign: 'center',
    align: 'left',
    minWidth: 100,
    slots: { default: 'ctnQty' },
    isTotalColumn: true,
  },
  {
    title: that.$l('table_label_quantity_remark') || '调整出货原因备注',
    field: 'remark',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 200,
      },
    },
  },
]
